const classes = {
  title: {
    fontSize: '32px', fontWeight: 700, lineHeight: '38.73px', mb: 4,
  },
};

export default classes;
